import { Space, Form, Input, Button, Select, Card } from "antd";
import { SearchOutlined, ReloadOutlined,DownloadOutlined,PlusOutlined } from "@ant-design/icons";
import service from "../../../@services";
import { useEffect, useState } from "react";
import useAddPackage from "../hooks/useAddPackage";
import PackagePageTable from "./components/PackagePageTable";
import AuthComponent from "../../../components/AuthComponent";
import * as Utils from '../../../@utils'
export default function Package(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [selectedRowKeys, onSelectChange] = useState([])
  const [tableData, setTableData] = useState({})
  const { addPackage } = useAddPackage();
  useEffect(() => {
    onSearch()
  }, []);
  const onSearch = ({pageIndex=1, pageSize=10} = {}) => {
    const pagination = {pageIndex: pageIndex, pageSize: pageSize}
    const params = Object.assign({},form.getFieldsValue(),pagination)
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    const data = await service.package.getPackagePageList(params)
    setLoading(false)
    if(data){
      setTableData(data)
    }
  }
  const onReset = (values) => {
    form.resetFields();
  };
  const exportPackage = async () => {
    const params = Object.assign({},form.getFieldsValue())
    const file = await service.package.exportPackage(params)
    const filename = '商品包装单位报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
        >
          <Form.Item name="id" label="单位编号">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item name="name" label="单位名称">
            <Input style={{ width: 200 }} placeholder="请输入" />
          </Form.Item>
          <Form.Item name="status" label="状态">
            <Select style={{ width: 200 }} placeholder="全部">
              <Select.Option value="">全部</Select.Option>
              <Select.Option value={1}>已启用</Select.Option>
              <Select.Option value={0}>已禁用</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/package-unit/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/package-unit/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Card>
        <Space style={{ display: "flex", padding: "15px 0", marginTop: "-24px" }}>
          <AuthComponent authKey="/package-unit/export">
            <Button type="primary" icon={<DownloadOutlined />} onClick={exportPackage}>导出</Button>
          </AuthComponent>
          <AuthComponent authKey="/package-unit/create">
            <Button type="primary" icon={<PlusOutlined />} onClick={()=>{addPackage().then(()=>onSearch())}}>新增</Button>
          </AuthComponent>
        </Space>
        <PackagePageTable 
          dataSource={tableData}
          rowSelection={rowSelection}
          loading={loading}
          editPackage={(record)=>{addPackage(record).then(()=>onSearch())}}
          handleTableChange={onSearch} />
      </Card>
    </Space>
  );
}
